import { inject, Injectable } from '@angular/core';
import { UserEntity, UserExistGQL, UserGeneralInfoGQL } from '@generated/gql';
import { BaseSubgraphService } from '@services/graph/base-subgraph.service';
import { map, Observable, retry } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserSubgraphService extends BaseSubgraphService {
  private readonly userExistGQL: UserExistGQL = inject(UserExistGQL);
  private readonly userGeneralInfoGQL: UserGeneralInfoGQL = inject(UserGeneralInfoGQL);
  constructor() {
    super();
  }

  userExist$(account: string): Observable<UserEntity | undefined> {
    return this.userExistGQL.fetch({ account: account.toLowerCase() }).pipe(
      map(x => x.data.userEntity as UserEntity | undefined),
      retry(this.retry()),
    );
  }

  userGeneralInfo$(account: string): Observable<UserEntity> {
    return this.userGeneralInfoGQL.fetch({ account: account.toLowerCase() }).pipe(
      map(x => x.data.userEntity as UserEntity),
      retry(this.retry()),
    );
  }
}
